import { render } from "./App.vue?vue&type=template&id=5300cf56&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5300cf56&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5300cf56"]])

export default __exports__